KXL.module('Components.AuthApp', function (AuthApp, KXL, Backbone, Marionette, $, _) {
	AuthApp.Router = Marionette.AppRouter.extend({
		appRoutes: {
			'login(/)': 'showLoginView',
			'forgot-password(/)': 'showForgotPasswordView',
		}
	});

    AuthApp.LoginModel = Backbone.Model.extend({
        defaults: {
            username: '',
            password: '',
            processing: false
        },
        validation: {
            username: {
                required: true
            },
            password: {
                required: true,
            }
        }
    });

	AuthApp.STEAM_LOGIN_URL = '/auth/steam?login';
	AuthApp.STEAM_CREDS_CHECK_URL = '/auth/steam/credentials';

	var API = Marionette.Controller.extend({
        // region View handlers
        showLoginView: function(options) {
            KXL.asyncRequest('async:load:module', 'common/components/auth/auth_modal').then(function() {
                const activeView = KXL.Components.AuthApp.AuthModal.Views.LOGIN;
                const authController = new AuthApp.AuthModal.Controller();
                authController.show(activeView, options);
            });
        },

        showSignupView: function(options) {
            KXL.asyncRequest('async:load:module', 'common/components/auth/auth_modal').then(function() {
                const activeView = KXL.Components.AuthApp.AuthModal.Views.SIGNUP;
                const authController = new AuthApp.AuthModal.Controller();
                authController.show(activeView, options);
            });
        },

        showForgotPasswordView: function(options) {
			if (KXL.currentUser) {
				return KXL.execute('home:show');
			}

            KXL.asyncRequest('async:load:module', 'common/components/auth/forgot_password').then(function() {
                const forgotPasswordController = new AuthApp.ForgotPassword.Controller();
                forgotPasswordController.show(options);
            });
        },

        showVerifyEmailView: function(options) {
            KXL.asyncRequest('async:load:module', 'common/components/auth/verify_email').then(function() {
                const verifyEmailController = new AuthApp.VerifyEmail.Controller();
                verifyEmailController.show(options);
            });
        },
        // endregion


        // region Social Auth
		doFbLogin: function (accessToken, data) {
			var deferred = $.Deferred();

			var fbLoginInfo = _.extend({}, data);
			KXL.Facades.Kixeye.fbLogin(accessToken).done(function (response) {
				fbLoginInfo.response = response;
				KXL.vent.trigger('info:fblogin:success', fbLoginInfo);
				KXL.execute('auth:handle:login:response', response, deferred);
			}).fail(function (error) {
					fbLoginInfo.error = error;
					KXL.vent.trigger('info:fblogin:error', fbLoginInfo);
					deferred.reject(error);
			});

			return deferred;
		},

		doGoogleLogin: function (idToken, data) {
			var deferred = $.Deferred();

			var googleLoginInfo = _.extend({}, data);
			KXL.Facades.Kixeye.googleLogin(idToken).done(function (response) {
				googleLoginInfo.response = response;
				KXL.vent.trigger('info:googlelogin:success', googleLoginInfo);
				KXL.execute('auth:handle:login:response', response, deferred);
			}).fail(function (response) {
				googleLoginInfo.error = response;
				KXL.vent.trigger('info:googlelogin:error', googleLoginInfo);
				deferred.reject(response);
			});

			return deferred;
		},

		startSteamLogin: function (viewListener, trackData, steamCredsCheckOnly) {
			var deferred = $.Deferred();
			var self = this;
			this.steamViewListener = viewListener;
			this.steamTrackData = trackData;

			KXL.vent.trigger('info:steamlogin:start', trackData);

			if (this.steamLoginWindow && !this.steamLoginWindow.closed) {
				this.steamLoginWindow.focus();
				return;
			}

			var url = steamCredsCheckOnly ?
					AuthApp.STEAM_CREDS_CHECK_URL:
					AuthApp.STEAM_LOGIN_URL;

			KXL.execute('fraud:fingerprint:get', function (deviceFingerprint) {
				return $.ajax({
					url: '/api/setDeviceFingerprint',
					type: 'POST',
					dataType: 'json',
					contentType: 'application/json',
					data: JSON.stringify({
						deviceFingerprint: deviceFingerprint
					})
				}).then(function() {
						self.steamLoginWindow = window.open(url, 'steamLoginWindow');
						if (!self.steamLoginWindow || self.boundSteamListener) {
							return;
						}
						self.steamLoginWindow.focus();
						self.boundSteamListener = true;

						self.listenToOnce(KXL.vent, 'steam:auth:result', function (data) {
							self.boundSteamListener = false;
							if (!self.steamLoginWindow || self.steamLoginWindow.closed) {
								return;
							}

							self.steamLoginWindow.close();
							self.steamLoginWindow = undefined;

							if (_.contains(['invalid', 'cancel'], data)) {
								return;
							}

							try {
								data = JSON.parse(data);
							} catch (error) {}

							var authPromise;
							if (steamCredsCheckOnly) {
								authPromise = $.Deferred();
								authPromise.resolve(data);
							} else {
								authPromise = self.doSteamLogin(data, self.steamTrackData);
								authPromise.fail(function (error) {
									// Errors from Steam auth come back as null or an error string.
									var analyticsData = _.extend(self.steamTrackData, {
										error: (error || 'unknown_error').replace(/\s+/g, '_')
									});
									KXL.vent.trigger('info:steamlogin:error', analyticsData);
									deferred.reject();
								});
							}

							if (self.steamViewListener && !self.steamViewListener.isClosed) {
								self.steamViewListener.trigger('steam:api:authenticated', authPromise);
							}

							deferred.resolve();
						}, false);
					});

			});

			return deferred;
		},

		doSteamLogin: function (data, trackData) {
			var deferred = $.Deferred();

			if (data && data.user) {
				var steamLoginInfo = _.extend({ response: data }, data, trackData);
				KXL.vent.trigger('info:steamlogin:success', steamLoginInfo);
				KXL.execute('auth:handle:login:response', steamLoginInfo, deferred);
			} else if (data && data.error === 'BANNED') {
				authAPI.showBannedDialog(data.data);
				deferred.reject(data);
			} else {
				deferred.reject(data);
			}

			return deferred;
		},
        // endregion
    });

	var authAPI = new API();

    KXL.addInitializer(function () {
        new AuthApp.Router({
            controller: authAPI
        });

        KXL.commands.setHandlers({
            'auth_modal:login:show': function(options) {
                authAPI.showLoginView(options);
            },
            'auth_modal:signup:show': function(options) {
                authAPI.showSignupView(options);
            },
            'auth_modal:forgot_password:show': function(options) {
                authAPI.showForgotPasswordView(options);
            },
            'auth_modal:verify_email:show': function(options) {
                authAPI.showVerifyEmailView(options);
            }
        });

        KXL.reqres.setHandlers({
			'fblogin:submit': function (authToken, data) {
				return authAPI.doFbLogin(authToken, data);
			},
			'googlelogin:submit': function (authToken, data) {
				return authAPI.doGoogleLogin(authToken, data);
			},
			'steamlogin:submit': function (view, trackData, steamCredsCheckOnly) {
				return authAPI.startSteamLogin(view, trackData, steamCredsCheckOnly);
			},
        })
    });
});
